import { Injectable } from '@angular/core';
import { AppSettings } from 'src/app/app.config';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AmlSearcherService {
  private apiUrl: string;
  
  constructor(private readonly http: HttpClient) { }

  getAmlDocs(): Observable<any> {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    const requestUrl = `${AppSettings.API_PROD_ENDPOINT}my-docs/aml-docs`;
    return this.http.get(requestUrl, { headers })
      .pipe(map((res: Response) => res));
  }
}
